import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { Card, Row, Space } from "@masterteam/mt-design-react";

import DoughnutChart from "../../DoughnutChart";

import useIsAr from "../../../Hooks/useIsAr";

import { ReactComponent as LevelOneIcon } from "../../../assets/images/level-one.svg";
import { ReactComponent as LevelTwoIcon } from "../../../assets/images/level-two.svg";

import "./style.scss";

const DashboardCard = ({
  data,
  kpiStatuses,
  projectStatuses,
  width = "350px",
  isSectorCard = false,
}) => {
  const [isAr] = useIsAr();
  const history = useHistory();

  return (
    <Card
      className="dashboard-card cursor"
      style={{ width }}
      onClick={() => {
        const isDetailsModalExists = document.getElementById("detailsModal");

        if (!isDetailsModalExists && !isSectorCard)
          history.push(`/splus/objective-details/${data.ID}`);
      }}
    >
      <Row className="dashboard-card__title" justify="between" size="small">
        <Space align="center" className="text">
          {isSectorCard ? (
            <div className="dashboard-card__sector-icon" />
          ) : +data?.Level === 1 ? (
            <LevelOneIcon fill={data?.ParentColor} />
          ) : (
            <LevelTwoIcon fill={data?.ParentColor} />
          )}
          <div> {isAr ? data?.ArabicName : data?.EnglishName}</div>
        </Space>
      </Row>

      <div className="dashboard-card__charts">
        <Space
          direction="vertical"
          align="center"
          style={{ borderInlineEnd: "1px solid var(--border-gray)" }}
        >
          <div className="doughnut-chart-title">
            <FormattedMessage id="dashboards.strategic-kpis" />
          </div>

          <DoughnutChart
            data={data?.KPIChart?.ChartData || []}
            statuses={kpiStatuses}
            count={data?.KPIChart?.Count}
            detailsTitle={"strategy-map.kpis-list"}
            detailsData={
              (isSectorCard ? data?.KPIChart?.Group : data?.KPIChart?.List) ||
              []
            }
            maxWidth="100px"
            textSize="16px"
            smallTooltip
            detailsGroupedByObjectives={isSectorCard}
          />
        </Space>

        <Space direction="vertical" align="center">
          <div className="doughnut-chart-title">
            <FormattedMessage id="dashboards.strategic-projects" />
          </div>

          <DoughnutChart
            data={data?.ProjectChart?.ChartData || []}
            statuses={projectStatuses}
            count={data?.ProjectChart?.Count}
            detailsTitle={"strategy-map.projects-list"}
            detailsData={
              (isSectorCard
                ? data?.ProjectChart?.Group
                : data?.ProjectChart?.List) || []
            }
            maxWidth="100px"
            textSize="16px"
            smallTooltip
            isProject
            detailsGroupedByObjectives={isSectorCard}
          />
        </Space>
      </div>
    </Card>
  );
};

export default DashboardCard;
